import { Location } from 'history';
import { urlSearchParamKeys } from '../constants/urlSearchParamKeys';

export default function getCampaignParameter(location: Location): string {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(urlSearchParamKeys.utmCampaign) as string;
}
